import { render, staticRenderFns } from "./page-12.vue?vue&type=template&id=6276603d&scoped=true&"
import script from "./page-12.vue?vue&type=script&lang=js&"
export * from "./page-12.vue?vue&type=script&lang=js&"
import style0 from "./page-12.vue?vue&type=style&index=0&id=6276603d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6276603d",
  null
  
)

export default component.exports